<div class="ng-select-div"> 
  <!-- <ion-row class="flexcentercenter"> -->
    <ion-row *ngIf="data?.title">
  
    <ion-col size="8">
      {{data?.title ?? 'Select '+data.collection}} 
    </ion-col>
    <!-- <ion-col size="4" class="ion-text-end" *ngIf="false" >
      <ion-button size="small"  fill="none" (click)="show_addedit_form=true" >+ New</ion-button>
    </ion-col> -->
  </ion-row>
  
  <!-- [addTag]="data.can_add ??  false" -->
  <ion-row>
    <ion-col size="8"></ion-col>
    <ion-col size="4">
      <ng-select #myNgSelect *ngIf="data && !loading_select" style="margin-top:-3px ;"
      [items]="items"
      [loading]="custLoading"
      bindLabel="name" 
      bindValue="id"
      [minTermLength]="1"
      [loading]="custLoading"
      [multiple]="data.multiple ?? false"
      [trackByFn]="trackByFn"
      [typeahead]="custTypeahead"
      (change)="setNewItem($event)"
      (clear)="selectedItem={};"
      (input)="onInputChange($event)"
      [(ngModel)]="selectedItem"
      appendTo="body"
      [disabled]="!role.product_addedit"
      placeholder="search by contributor name"
      >
  
      
      
      <ng-template ng-option-tmp ng-label-tmp let-item="item" let-index="index" let-search="searchTerm">
        <div style="margin: 2px 0px;" class="card" *ngIf="item?.name">
            <div style="white-space: normal;" [ngSwitch]="data.collection">
      
              <ng-container *ngSwitchCase="'tracks'">
                  
                <ion-item lines="none">
                  <ion-avatar slot="start">
                    <ion-icon style="width:100%;height:100%" name="musical-notes-outline"></ion-icon>
                  </ion-avatar>
                  <ion-label>
                    <h2> {{item?.name}}</h2>
                    <p>{{item?.isrc}}</p> 
      
                  </ion-label>
                </ion-item>
      
                </ng-container>
      
      
                <ng-container *ngSwitchCase="'customers'">
                     
                  <ion-item>
                    <ion-avatar slot="start">
                      <img [src]="apiService.get_cdn_url(item?.image ?? 'e2475c9f-1923-400c-b49e-110b13c2bf49')" />
                    </ion-avatar>
                    <ion-label>
                      <h2>#{{item.idseq_app}} : {{item?.name}}</h2>
                      <p>+{{item?.mobile}}</p>
                      <ion-badge  color="primary" *ngFor="let tag of item.tags">{{tag}}</ion-badge> 
        
                    </ion-label>
                  </ion-item>
        
                  </ng-container>
      
      
                <ng-container *ngSwitchDefault>
                  <b>{{item.name}}</b>
       
                </ng-container>
      
            </div>
        </div>
      </ng-template>
      
      <ng-template ng-typetosearch-tmp>
        <div class="ng-option disabled">
            Start typing...
        </div>
      </ng-template>
      
      <ng-template ng-notfound-tmp let-search="searchTerm">
        <div class="ng-option disabled">
            <!-- No items found matching "{{search}}" -->
            
            <!-- <button ion-button>Add "{{search}}"</button> -->
            <span (click)="addItem(search)" style="cursor:pointer">Add Item "{{search}}"</span>
        </div>
      </ng-template>
      
      </ng-select>
    </ion-col>

    <ion-col size="4"></ion-col>

  
    <!-- <ion-col size="3" *ngIf="data.collection!='tracks'">
      <ion-button *ngIf="role.product_addedit" size="small"  fill="none" (click)="show_addedit_form=true" >+ New</ion-button>
    </ion-col> -->
  </ion-row>
  
  </div>
  
  
  
  
